const debug: boolean = false
// const debug: string = "ExportToCsv"

export default function exportToCsv(list: any[], filename: string): void {
    debug && console.log(debug, 'exportToCsv', list, filename)

    let csvContent: string = ''
    list.forEach(arr => {
        csvContent += arrayToCsvRow(arr)
    })

    // @ts-ignore
    if (window.navigator.msSaveOrOpenBlob) {
        const blob: Blob = new Blob(['\ufeff', csvContent], {
            type    : 'text/csv;charset=utf-8',
            // @ts-ignore
            encoding: 'utf-8'
        });
        // @ts-ignore
        navigator.msSaveOrOpenBlob(blob, filename)
    } else {
        const link = document.createElement('a')
        link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent('\ufeff' + csvContent))
        link.setAttribute('target', '_blank')
        link.setAttribute('download', filename)
        link.innerHTML = 'Click here to download'
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
}

function prepareCsvField(value: any): string {
    if (value === null || value === undefined) value = ''
    //const strValue: String = new String(value)
    const strValue: String = String(value)
    const qv: string = strValue.replace(/"/g, '""')
    return '"' + qv + '"'
}

function arrayToCsvRow(arr: any[]): string {
    const csvArr: any[] = []
    arr.forEach(val => {
        csvArr.push(prepareCsvField(val))
    })
    return csvArr.join(',') + '\r\n'
}